import React from 'react';
import { View } from 'react-native';
import RatingStars, { RatingStarsProps } from './RatingStars';
import BodyText from './ui/BodyText';

import './Rating.module.scss';

export type RatingProps = RatingStarsProps & {
  ratingCount?: number;
  ratingStars: number;
  testID?: string;
};

const Rating: React.FCWithChildren<RatingProps> = ({
  ratingCount = null,
  ratingStars,
  testID = null,
  ...props
}) => (
  <View styleName="holder" testID={testID}>
    <RatingStars ratingStars={ratingStars} {...props} />
    {ratingCount !== null && (
      <BodyText theme="client" appearance="small" styleName="text">({ratingCount})</BodyText>
    )}
  </View>
);

export default Rating;
